import { render, staticRenderFns } from "./CredorContatos.vue?vue&type=template&id=08ffce6e"
import script from "./CredorContatos.vue?vue&type=script&lang=js"
export * from "./CredorContatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports